import React, { useCallback } from "react";

import type { SidebarEntityItemProps } from "./treeEditor.types";

import styles from "./SidebarEntityItem.module.css";

const SidebarEntityItem = ({ entity, isActive, onSelect }: SidebarEntityItemProps) => {
	const onClick = useCallback((): void => onSelect(entity), [entity, onSelect]);
	const className = isActive
		? `${styles.entityItemButton} ${styles.entityItemButtonActive}`
		: styles.entityItemButton;

	return (
		<li>
			<button className={className} onClick={onClick} type="button">
				<span>{entity.title}</span>
			</button>
		</li>
	);
};

export default SidebarEntityItem;
